import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { PaginatedRequest } from '@wajeez-web/core/api';
import { MediaHelpers } from '@wajeez-web/core/api';
import JSZip from 'jszip';
import mime from 'mime';
import { saveAs } from 'file-saver';

export interface getAllContentEntityAudiosProps extends PaginatedRequest {
  ContentEntityId?: string;
}
export const getAllContentEntityAudios: ApiMethod<
  getAllContentEntityAudiosProps,
  Server.ContentEntityAudioOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityAudios_Client(
      undefined,
      contentClient
    );
    const response = await client.admin_ContentEntityAudios_get_V1(
      undefined,
      data.ContentEntityId,
      data.page,
      data.pageSize
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

// export const addAudio: ApiMethod<
//   Server.AudioChapterInput,
//   number,
//   any
// > = async (data, { dispatch, rejectWithValue }) => {
//   try {
//     const client = new Server.Server_ContentEntityAudios_Client(
//       undefined,
//       contentClient
//     );
//     const response = await client.admin_ContentEntityAudios_addAudio_post_V1(
//       data
//     );
//     if (response.success && response.data) {
//       return response.data;
//     }
//     return rejectWithValue(!response);
//   } catch (error: any) {
//     // Show alert
//     const errors = { ...error.response }.data;
//     dispatch(
//       CommonActions.setAlert({
//         type: AlertType.WARNING,
//         messages: JSON.parse(errors).errors || [
//           { message: 'Something went wrong' },
//         ],
//       })
//     );
//     return rejectWithValue(error);
//     throw error;
//   }
// };

// export const removeAudio: ApiMethod<
//   Server.RemoveContentEntityAudio,
//   void,
//   any
// > = async (data, { dispatch, rejectWithValue }) => {
//   try {
//     const client = new Server.Server_ContentEntityAudios_Client(
//       undefined,
//       contentClient
//     );
//     const response = await client.admin_ContentEntityAudios_removeAudio_post_V1(
//       data
//     );
//     if (response.success) {
//       return;
//     }
//     return rejectWithValue(!response);
//   } catch (error: any) {
//     // Show alert
//     const errors = { ...error.response }.data;
//     dispatch(
//       CommonActions.setAlert({
//         type: AlertType.WARNING,
//         messages: JSON.parse(errors).errors || [
//           { message: 'Something went wrong' },
//         ],
//       })
//     );
//     return rejectWithValue(error);
//     throw error;
//   }
// };

// export const setDefaultAudio: ApiMethod<
//   Server.SetContentEntityAudioAsDefault,
//   void,
//   any
// > = async (data, { dispatch, rejectWithValue }) => {
//   try {
//     const client = new Server.Server_ContentEntityAudios_Client(
//       undefined,
//       contentClient
//     );
//     const response =
//       await client.admin_ContentEntityAudios_setDefaultAudio_post_V1(data);
//     if (response.success) {
//       return;
//     }
//     return rejectWithValue(!response);
//   } catch (error: any) {
//     // Show alert
//     const errors = { ...error.response }.data;
//     dispatch(
//       CommonActions.setAlert({
//         type: AlertType.WARNING,
//         messages: JSON.parse(errors).errors || [
//           { message: 'Something went wrong' },
//         ],
//       })
//     );
//     return rejectWithValue(error);
//     throw error;
//   }
// };

// export const updateAudio: ApiMethod<
//   Server.EditContentEntityAudioInput,
//   void,
//   any
// > = async (data, { dispatch, rejectWithValue }) => {
//   try {
//     const client = new Server.Server_ContentEntityAudios_Client(
//       undefined,
//       contentClient
//     );
//     const response = await client.admin_ContentEntityAudios_updateAudio_put_V1(
//       data
//     );
//     if (response.success) {
//       return;
//     }
//     return rejectWithValue(!response);
//   } catch (error: any) {
//     // Show alert
//     const errors = { ...error.response }.data;
//     dispatch(
//       CommonActions.setAlert({
//         type: AlertType.WARNING,
//         messages: JSON.parse(errors).errors || [
//           { message: 'Something went wrong' },
//         ],
//       })
//     );
//     return rejectWithValue(error);
//     throw error;
//   }
// };

export interface DownloadAudioVariables {
  id: string;
  name?: string;
}

export const downloadAudio: ApiMethod<
  DownloadAudioVariables,
  void,
  any
> = async ({ id, name }, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_ContentEntityAudios_Client(
      undefined,
      contentClient
    );
    const response = await client.admin_ContentEntityAudios_download_get_V1(
      undefined,
      id
    );

    if (response.success && response?.data && response?.data?.length > 0) {
      const zip = new JSZip();
      const zipFolder = zip.folder(`${makeValidFileName(name ?? id)}`);

      if (zipFolder == null) return;

      for (let index = 0; index < response.data.length; index++) {
        const element = response.data[index];

        const blob = await MediaHelpers.getMediaBlobById(
          element.audioReference || ''
        );

        zipFolder.file(
          `${index}-${makeValidFileName(element.contentEntityTitle)}-${
            element.contentEntityAudioId
          }.${mime.getExtension(blob.type)}`,
          blob
        );
      }
      const generatedZip = await zip.generateAsync({ type: 'blob' });
      saveAs(generatedZip, `${makeValidFileName(name ?? id)}`);
    }
    return rejectWithValue(!response);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

// make name valid for file system
const makeValidFileName = (name: string | undefined) => {
  return name?.replace(/[\\/:*?"<>|]/g, '_');
};
